import React, { Suspense } from "react";
const PersonalHealthCheckPageWrapper = React.lazy(() => import("../components/PersonalHealthCheckPageWrapper"));

function PersonalHealthCheckPage() {
  return (
    <Suspense
      fallback={
        <>
          Loading...
        </>
      }
    >
      <PersonalHealthCheckPageWrapper />
    </Suspense>
  );
}

export default PersonalHealthCheckPage;
